var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer mt-auto footer-light"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v("© Sistema Instituto Campechano")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }